import { configureStore } from "@reduxjs/toolkit";
import stepReducer from './redux/reducers/stepSlice';
import themeReducer from './redux/reducers/themeSlice';

export const Store = configureStore({
  reducer: {
    step: stepReducer,
    theme: themeReducer,
  },
});
export type RootState = ReturnType<typeof Store.getState>;
export type AppDispatch = typeof Store.dispatch;
export default Store;